import Vector3 from "../../images/home/Vector 3.png";
import Vector4 from "../../images/home/Vector 4.png";
import Vector5 from "../../images/home/Vector 5.png";
import QuestionMark from "../../images/home/question-mark.png";
import TestimonialName from "../../images/home/testimonial-name.png";
import TestimonialName1 from "../../images/home/testimonial-name1.png";
import TestimonialName2 from "../../images/home/testimonial-name2.png";
import Plus from "../../images/home/Add_Plus.png";
import Minus from "../../images/minus.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

function HomeFaqs() {
  const navigate = useNavigate();
  const [dropdownActive, setDropDownActive] = useState("");
  
  return (
    <div className="home-faqs">
      <div className="heading">
        <h1>Real experiences from clients who've seen the results.</h1>
        <p className="heading-p">
          It's not just what we build — it's how it works for the people who use
          it every day
        </p>
        <button onClick={() => navigate("/products")}>
          <p>Learn more</p>
          <div />
        </button>
      </div>
      <div className="testimonial">
        <div className="testimonial-body">
          <div className="comment">
            <p>
              "Working with Brandonetech felt like an extension of our own team.
              They didn't just build software — they solved real problems, fast.
              We saw improvements in efficiency within weeks.”
            </p>
            <p>
              “We've worked with several companies in the past, but none were as
              responsive or thoughtful as Brandonetech. They delivered on time,
              adapted quickly, and exceeded expectations.”
            </p>
            <p>
              “What stood out about Brandonetech was their ability to listen.
              They took our ideas, refined them, and turned them into a product
              our users love. We're already seeing traction.”
            </p>
            <p>
              "Working with Brandonetech felt like an extension of our own team.
              They didn't just build software — they solved real problems, fast.
              We saw improvements in efficiency within weeks.”
            </p>
            <p>
              “We've worked with several companies in the past, but none were as
              responsive or thoughtful as Brandonetech. They delivered on time,
              adapted quickly, and exceeded expectations.”
            </p>
            <p>
              “What stood out about Brandonetech was their ability to listen.
              They took our ideas, refined them, and turned them into a product
              our users love. We're already seeing traction.”
            </p>
            <p>
              "Working with Brandonetech felt like an extension of our own team.
              They didn't just build software — they solved real problems, fast.
              We saw improvements in efficiency within weeks.”
            </p>
            <p>
              “We've worked with several companies in the past, but none were as
              responsive or thoughtful as Brandonetech. They delivered on time,
              adapted quickly, and exceeded expectations.”
            </p>
            <p>
              “What stood out about Brandonetech was their ability to listen.
              They took our ideas, refined them, and turned them into a product
              our users love. We're already seeing traction.”
            </p>
            <p>
              "Working with Brandonetech felt like an extension of our own team.
              They didn't just build software — they solved real problems, fast.
              We saw improvements in efficiency within weeks.”
            </p>
            <p>
              “We've worked with several companies in the past, but none were as
              responsive or thoughtful as Brandonetech. They delivered on time,
              adapted quickly, and exceeded expectations.”
            </p>
            <p>
              “What stood out about Brandonetech was their ability to listen.
              They took our ideas, refined them, and turned them into a product
              our users love. We're already seeing traction.”
            </p>
          </div>
          <div className="names">
            <div className="column">
              <div>
                <img src={TestimonialName} alt="name" />
                <p>Grace M. – PSA, NMDPRA</p>
              </div>
              <div>
                <img src={TestimonialName1} alt="name" />
                <p>Munachi H. – COO, NovaBank</p>
              </div>
              <div>
                <img src={TestimonialName2} alt="name" />
                <p>Oscar A. – COO, RetailTech Systems</p>
              </div>
              <div>
                <img src={TestimonialName} alt="name" />
                <p>Grace M. – PSA, NMDPRA</p>
              </div>
              <div>
                <img src={TestimonialName1} alt="name" />
                <p>Munachi H. – COO, NovaBank</p>
              </div>
              <div>
                <img src={TestimonialName2} alt="name" />
                <p>Oscar A. – COO, RetailTech Systems</p>
              </div>
            </div>
          </div>
        </div>
        <div className="active-bar">
          <canvas className="active-canvas" />
          <canvas className="inactive-canvas" />
          <canvas className="inactive-canvas2" />
        </div>
      </div>
      <div className="faq-heading">
        <img src={QuestionMark} alt="heading" />
        <p>Frequently Asked Questions</p>
      </div>
      <div className="faqs-div">
        <div
          className="faqs-questions"
          onClick={() => {
            dropdownActive !== "dropdown1"
              ? setDropDownActive("dropdown1")
              : setDropDownActive("");
          }}
        >
          <div>
            <p className="faqs-questions-title">What we do at Brandone?</p>
            <h2 className={dropdownActive === "dropdown1" ? "visible" : ""}>
              BrandOne is an Enterprise Resource Solution/platform company, that
              helps organizations, business(small and large scale) to automate
              their process and scale their businesses. Brandone helps them to
              bring their technological dreams for their companies/business to
              life. They develop bespoke solutions tailored to company/business
              needs.
            </h2>
          </div>
          {dropdownActive !== "dropdown1" ? (
            <img className="faqs-questions-dropdown" src={Plus} alt="plus" />
          ) : (
            <img className="faqs-questions-minus" src={Minus} alt="minus" />
          )}
        </div>
        <div
          className="faqs-questions"
          onClick={() => {
            dropdownActive !== "dropdown2"
              ? setDropDownActive("dropdown2")
              : setDropDownActive("");
          }}
        >
          <div>
            <p className="faqs-questions-title">Our development framework?</p>
            <h2 className={dropdownActive === "dropdown2" ? "visible" : ""}>
              We use Agile/scrum to manage our projects, SOLID/DRIVE design
              principles to guide our development. We use .netcore (latest),
              Angular js, React js, React Native for development.
            </h2>
          </div>
          {dropdownActive !== "dropdown2" ? (
            <img className="faqs-questions-dropdown" src={Plus} alt="plus" />
          ) : (
            <img className="faqs-questions-minus" src={Minus} alt="minus" />
          )}
        </div>
        <div
          className="faqs-questions"
          onClick={() => {
            dropdownActive !== "dropdown3"
              ? setDropDownActive("dropdown3")
              : setDropDownActive("");
          }}
        >
          <div>
            <p className="faqs-questions-title">What is an ERP?</p>
            <h2 className={dropdownActive === "dropdown3" ? "visible" : ""}>
              Enterprise Resource Platform, its software solution that aids
              companies/businesses processes in an integrated system. It helps
              drive efficiency and provide intelligent ways of doing things.
            </h2>
          </div>
          {dropdownActive !== "dropdown3" ? (
            <img className="faqs-questions-dropdown" src={Plus} alt="plus" />
          ) : (
            <img className="faqs-questions-minus" src={Minus} alt="minus" />
          )}
        </div>
        <div
          className="faqs-questions"
          onClick={() => {
            dropdownActive !== "dropdown4"
              ? setDropDownActive("dropdown4")
              : setDropDownActive("");
          }}
        >
          <div>
            <p className="faqs-questions-title">
              How long has Brandone been in existence?
            </p>
            <h2 className={dropdownActive === "dropdown4" ? "visible" : ""}>
              BrandOne has been in existence for 10 years now, the company was
              established in October 20th, 2013.
            </h2>
          </div>
          {dropdownActive !== "dropdown4" ? (
            <img className="faqs-questions-dropdown" src={Plus} alt="plus" />
          ) : (
            <img className="faqs-questions-minus" src={Minus} alt="minus" />
          )}
        </div>
      </div>
      <img className="vector4" src={Vector4} alt="vector" />
      <img className="vector5" src={Vector5} alt="vector" />
      <img className="vector3" src={Vector3} alt="vector" />
    </div>
  );
}

export default HomeFaqs;
